import React from 'react'
import { Tag, Space } from 'antd'
import { useTranslation } from 'react-i18next'
import { WarningFilled } from '@ant-design/icons'
import { useOrderStatusLabel } from '@constants/order'

// 定義狀態設定 (Source of Truth)
const STATUS_CONFIG: Record<string, { color: string; bordered: boolean }> = {
  pending: { color: 'default', bordered: true },
  allocated: { color: 'cyan', bordered: true },
  partial_allocated: { color: 'warning', bordered: true },
  processing: { color: 'processing', bordered: true },
  partial_shipped: { color: 'warning', bordered: true },
  shipped: { color: 'success', bordered: false },
  canceled: { color: 'default', bordered: false },
  out_of_stock: { color: 'error', bordered: true },
  draft: { color: 'default', bordered: false },
  awaiting_payment: { color: 'purple', bordered: true },
  merged: { color: 'blue', bordered: true },
}

interface OrderStatusLabelProps {
  status?: string;
  is_held?: boolean;
}

const OrderStatusLabel: React.FC<OrderStatusLabelProps> = ({ status, is_held = false }) => {
  const { t } = useTranslation()
  const orderStatusLabel = useOrderStatusLabel()
  const config = (status && STATUS_CONFIG[status]) || { color: 'default', bordered: false }

  return (
    <Space size={4} wrap style={{ flexWrap: 'nowrap' }}>
      <Tag color={config.color} bordered={config.bordered}>
        {orderStatusLabel(status)}
      </Tag>
      {is_held && (
        <Tag color="error" bordered={false} icon={<WarningFilled />}>
          {t('shared.orders.list.badges.held')}
        </Tag>
      )}
    </Space>
  )
}

export default OrderStatusLabel
